import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import Body from '@luna-protocol/core/src/components/Body/Body';
import { useAuth } from '@luna-protocol/core/src/utils/useAuth.ts';
import DealStatusLayout from '../DealStatusLayout/DealStatusLayout.tsx';
import ApprovalDetails from '../ApprovalDetails/ApprovalDetails.tsx';
import ApplicantDetails from '../ApplicantDetails/ApplicantDetails.tsx';
import PlaidStatus from '../PlaidStatus/PlaidStatus.tsx';
import messages from './DealStatus.messages.ts';
import { useGetApplicationSummary } from '../../queries/useGetApplicationSummary.ts';
import styles from './DealStatus.module.scss';

const DealStatus = () => {
  useAuth();
  const { loan_application_id } = useParams();
  const { data, isLoading = true } = useGetApplicationSummary(loan_application_id as string);
  const { formatMessage } = useIntl();

  const primaryApplicant = useMemo(() => {
    return data?.applicants.find(({ is_primary }) => is_primary);
  }, [data]);

  const coApplicant = useMemo(() => {
    return data?.applicants.find(({ is_primary }) => !is_primary);
  }, [data]);

  if (isLoading) {
    return null;
  }

  return (
    <Body fullWidth stretched>
      {data ? (
        <>
          <h2 className={styles.dealStatusV2__title}>{formatMessage(messages.appOverview)}</h2>
          <div className={styles.dealStatusV2__appStatus}>
            <div>
              <div className={styles.dealStatusV2__rowContainer}>
                <span className={styles.dealStatusV2__rowLabel}>{formatMessage(messages.appStatus)}</span>
                <span>{data?.status}</span>
              </div>
            </div>
          </div>
          <DealStatusLayout
            leftContent={
              <>
                <ApprovalDetails />
                <PlaidStatus className="mt-2" />
              </>
            }
            rightContent={
              <>
                <ApplicantDetails customerID={primaryApplicant?.customer_id} />
                {coApplicant ? (
                  <ApplicantDetails customerID={coApplicant?.customer_id} isCoapplicant className="mt-2" />
                ) : null}
              </>
            }
          />
        </>
      ) : (
        <p className="showError"> This page has encountered an error. </p>
      )}
    </Body>
  );
};

export default DealStatus;
